<script type="text/babel">
  import Base from './BaseMultidimentionalChart.vue'

  export default Base.extend({
    name: "HorizontalBarChart",
    methods: {
      getChartType: function () {
        return "horizontalBar";
      }
    }
  })
</script>



// WEBPACK FOOTER //
// HorizontalBarChart.vue?c98ff680